import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { AuthGuardData, createAuthGuard } from 'keycloak-angular';
import Keycloak from 'keycloak-js';
import { UserService } from '@services/user/user.service';
import { SettingsService } from '@services/settings/settings.service';
import { ApiAccountsService } from '@services/api-account/api-accounts.service';
import { AuthorizationService } from '@services/authorization/authorization.service';

const isAccessAllowed = async (route: ActivatedRouteSnapshot, _: RouterStateSnapshot, authData: AuthGuardData) => {
    const { authenticated } = authData;
    return new Promise<boolean>((resolve) => {
        const keycloak = inject(Keycloak);
        const userService = inject(UserService);
        const settingsService = inject(SettingsService);
        const authorizationService = inject(AuthorizationService);
        const apiAccountsService = inject(ApiAccountsService);

        const ensureAuthenticated = (): Promise<void> => {
            if (!authenticated) {
                return keycloak.login().then(() => { });
            }
            return Promise.resolve();
        };

        ensureAuthenticated()
            .then(async () => {
                if (!userService.userProfile) {
                    console.log('loadProfile');
                    await userService.loadUserProfile();
                }
                if (!settingsService.settings) {
                    console.log('loadSettings');
                    await settingsService.loadSettings();
                }
                if (!apiAccountsService.apiAccounts) {
                    console.log('loadEnabledApiKeys');
                    await apiAccountsService.loadEnabledApiKeys();
                }

                const module = route.data['module'];
                const permission = route.data['permission'] || 'READ';

                if (
                    settingsService.settings.roleAuthorizations === undefined ||
                    settingsService.settings.roleAuthorizations.length === 0
                ) {
                    return resolve(authorizationService.roles.includes('admin'));
                } else if (!module) {
                    return resolve(true);
                } else {
                    return resolve(authorizationService.hasComponentAccess(module, permission));
                }
            })
            .catch((error) => {
                console.error(error);
                resolve(false);
            });
    });
};
export const canActivateAuthRole = createAuthGuard<CanActivateFn>(isAccessAllowed);
